<template>
  <v-card
    class="message-wrapper align-center pa-4 rounded-xl mx-auto"
    width="100%"
    outlined
  >
    <v-textarea
      v-model="newMessage"
      @keyup.enter="onEnter"
      :placeholder="$t('chat_input_placeholder')"
      :disabled="sendingMessage"
      rows="1"
      auto-grow
      flat
      solo
      dense
      hide-details
      autofocus
    ></v-textarea>

    <v-chip
      v-if="file"
      @click:close="clearFile"
      class="ma-1 mx-0"
      close
    >
      <v-icon
        color="#0F9D58"
        left
      >mdi-google-spreadsheet
      </v-icon>
      <span class="text-truncate">
        {{ file.name }}
      </span>
    </v-chip>

    <v-card-actions class="pa-0 pt-2">
      <v-btn
        @click="openFileModal"
        :disabled="sendingMessage || null != file"
        outlined
        x-small
        fab
        color="grey darken-1"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        @click="sendMessage"
        :disabled="!newMessage.trim() || sendingMessage"
        :loading="sendingMessage"
        color="primary"
        x-small
        fab
        depressed
      >
        <v-icon>mdi-send-variant-outline</v-icon>
      </v-btn>
    </v-card-actions>

    <DefaultModal
      @submit="storeFile"
      :title="$t('file_upload')"
      submit-button-text="upload"
      ref="fileModal"
    >
      <template v-slot:content>
        <UploadField
          ref="uploadField"
          :rules="[v => (!!v && v.size > 0) || $t('form_rules.mandatory')]"
          :multiple="false"
          :accept=allowedFileTypes.join()
        />
      </template>
    </DefaultModal>
  </v-card>
</template>

<style scoped>
  .message-wrapper {
    border-color: lightgrey;
    box-shadow: 0px -10px 15px rgba(255,255,255,0.3), 0px -15px 25px rgba(255,255,255,0.6);

  }

  ::v-deep .v-input__slot {
    padding: 2px !important;
    margin: -4px 0 8px !important;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
  }

</style>

<script>
  import DefaultModal from '@/components/DefaultModal.vue'
  import UploadField from '@/components/content/default/Form/UploadField.vue'

  export default {
    name: "ChatInput",

    components: {
      DefaultModal,
      UploadField,
    },

    props: {
      sendingMessage: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        newMessage: "",
        file: null,
        allowedFileTypes: [
          'text/csv',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ],
      }
    },

    methods: {
      sendMessage() {
        if (this.newMessage.trim() === "") return

        this.$emit("send-message", this.newMessage)

        this.newMessage = ""
        this.clearFile()
      },

      openFileModal() {
        this.$refs.fileModal.openModal()
      },
      
      onEnter(event) {
        if (
          !event.shiftKey && 
          !event.ctrlKey && 
          !event.altKey && 
          !event.metaKey
        ) {
          event.preventDefault()
          this.sendMessage()
        }
      },

      storeFile() {
        const file = this.$refs.uploadField.getFiles()
        this.file = file

        this.$emit("selected-file", this.file)

        this.$refs.fileModal.closeModal()
        this.$refs.fileModal.resetForm()
      },

      getFile() {
        return this.file
      },

      clearFile() {
        this.file = null
      },
    },
  }
</script>
